import * as React from 'react';
import { Box,Backdrop, Button, CircularProgress, Grid, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Divider from '@mui/material/Divider';

const API = require("../../data/network/API");

export default function Menu() {
    const navigate = useNavigate();

    
    const [open, setOpen] = React.useState(false);


    function takePicture(){
        navigate("/main/home/dynamics/photo")
    }

    return (
        <Box sx={{ flexGrow: 1, overflow: 'hidden', px: 3, mt:10 }}>    

            <Grid container spacing={1} >
            <Grid item xs={12} sm={8} md={7}>
                <Stack spacing={2} sx={{width:"100%"}}>
                <Typography variant="h6" sx={{fontWeight:"bold"}}>¿Como ganas?</Typography>
                <Typography variant="body1">Completa cada una de las dinamicas y acumula PUNTOS DE LEALTAD</Typography>
                </Stack>
            </Grid>
            <Grid item  xs={1}sm={4} md={5}/>
            </Grid>
            <Divider  sx={{ mt:4, mb:4, }}/>
            <Grid container >
                <Grid item xs={12} sm={8} md={6}>
                    <Stack spacing={2}> 
                        <Button variant="contained" color='secondary' fullWidth onClick={takePicture}>
                        Dinámicas "Foto de exito"
                        </Button>
                        <Stack spacing={0}>
                            <Typography  component="li"  variant="body1">Selecciona una dinámica.</Typography>
                            <Typography  component="li"  variant="body1">Toma una foto del producto especificado.</Typography>
                            <Typography   component="li" variant="body1">Verifica tu foto.</Typography>
               
                        </Stack>
                        <Divider  sx={{ mt:4, mb:4, }}/>
                        <Button variant="contained" color='secondary' fullWidth onClick={takePicture}>
                        Dinámicas "Vendamos más"
                        </Button>
                        <Stack spacing={0}>
                            <Typography  component="li"  variant="body1">Selecciona una dinámica.</Typography>
                            <Typography  component="li"  variant="body1">Dinos cuanto producto vendiste.</Typography>
                            <Typography   component="li" variant="body1">Toma una foto.</Typography>
                            <Typography   component="li" variant="body1">Mandanos tu evidencia</Typography>
               
                        </Stack>
                    </Stack>
                </Grid>
                <Grid item  xs={0}sm={4} md={6}/>
            </Grid>
            <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={open}>
                <CircularProgress color="inherit" />
            </Backdrop>

        </Box>
    )
}